import { DateTime } from 'luxon';

import SessionHelper from './SessionHelper';

class TimetableHelper {
  static sort(isCategoryFilter, items, sortBy, filter, activityList) {
    const buckets = {};
    for (const eventSeries of items) {
      for (const sessionSeries of eventSeries.subEvent) {
        for (const subEvent of sessionSeries.subEvent || []) {
          if (
            SessionHelper.isWithinFilter(
              isCategoryFilter,
              eventSeries,
              subEvent,
              filter,
              activityList
            )
          ) {
            const startTime = DateTime.fromISO(subEvent.startDate);
            let endTime = DateTime.fromISO(subEvent.endDate);
            if (endTime.second === 59) {
              endTime = endTime.plus({ seconds: 1 });
            }

            const derivedItem = Object.assign({}, eventSeries);
            delete derivedItem.subEvent;
            derivedItem.subEvent = [Object.assign({}, subEvent)];

            const category = this.getCategory(derivedItem, sortBy);

            if (typeof buckets[category] === 'undefined') {
              buckets[category] = [[]];
            }

            let wasBucketed = false;
            for (const bucket of buckets[category]) {
              let isConflict = false;
              for (const item of bucket) {
                const itemStartTime = DateTime.fromISO(item.subEvent[0].startDate);
                const itemEndTime = DateTime.fromISO(item.subEvent[0].endDate);
                if (startTime < itemEndTime && endTime > itemStartTime) {
                  isConflict = true;
                  break;
                }
              }
              if (!isConflict) {
                bucket.push(derivedItem);
                wasBucketed = true;
                break;
              }
            }

            if (!wasBucketed) {
              buckets[category].push([derivedItem]);
            }
          }
        }
      }
    }
    return buckets;
  }

  static getCategory(item, sortBy) {
    switch (sortBy) {
      case 'activity':
        if (item.activity && item.activity.length > 0) {
          return item.activity[0].prefLabel || TimetableHelper.DEFAULT_CATEGORY;
        }
        return TimetableHelper.DEFAULT_CATEGORY;
      default:
        return TimetableHelper.DEFAULT_CATEGORY;
    }
  }
}

TimetableHelper.DEFAULT_CATEGORY = '';

export default TimetableHelper;
